import Button from "../components/button/Button"
import Shorts from "../components/shorts/Shorts"
import ShortsRec from "../components/shorts/ShortsRec"
import styles from "./ThirdScreen.module.css"
import result1 from "../images/הילה קוסייב המלצות תמונות 1.png"
import result2 from "../images/הילה קוסייב המלצות תמונות 2.png"
import result3 from "../images/הילה קוסייב המלצות תמונות 3.png"
import result4 from "../images/הילה קוסייב המלצות תמונות 4.png"
import video1 from "../videos/הילה סרטון המלצה 1.mp4"
import video2 from "../videos/הילה סרטון המלצה 2.mp4"
import video3 from "../videos/הילה סרטון המלצה 3.mp4"
import video4 from "../videos/הילה סרטון המלצה 4.mp4"
import video5 from "../videos/הילה סרטון המלצה 5.mp4"
import { useRef, useEffect } from "react"
import ScrollReveal from "scrollreveal"
import ShortsOne from "../components/shorts/ShortsOne"

const ThirdScreen = () => {
    const imageRef1 = useRef(null)
    const imageRef2 = useRef(null)
    const imageRef3 = useRef(null)
    const imageRef4 = useRef(null)
    
    const videoRef1 = useRef(null)
    const videoRef2 = useRef(null)
    const videoRef3 = useRef(null)
    const videoRef4 = useRef(null)

    useEffect(() => {
        const sr = ScrollReveal({
            origin: 'top',
            distance: '50px',
            duration: 800,
            easing: 'ease-out',
            opacity: 0,
            reset: false
        })

        sr.reveal(imageRef1.current, { delay: 0 })
        sr.reveal(imageRef2.current, { delay: 200 })
        sr.reveal(imageRef3.current, { delay: 400 })
        sr.reveal(imageRef4.current, { delay: 600 })
        
        sr.reveal(videoRef1.current, { delay: 0 })
        sr.reveal(videoRef2.current, { delay: 200 })
        sr.reveal(videoRef3.current, { delay: 400 })
        sr.reveal(videoRef4.current, { delay: 600 })
    }, [])
    
    return <>
        <div className={styles.title}>איך זה נראה בפועל</div>
        <div className={styles.description}>
            הנה דורון, אחד הלקוחות, מסביר איך הגיע מביישנות מול מצלמה…
            לסרטונים שמכרו בשבילו 👇
        </div>
        <ShortsOne/>
        <div className={styles.title}>ליוויתי עשרות בעלי עסקים</div>
        <div className={styles.description}>שיצאו ממני עם תכנים שנראים ככה:</div>
        <Shorts/>
        <div className={styles.title}>שבסוף התהליך גם רצו לפרגן:</div>
        
        <div className={styles.imageGallery}>
            <div className={styles.imageWrapper} ref={imageRef1}>
                <img src={result1} alt="תוצאה 1" className={styles.galleryImage} />
            </div>
            <div className={styles.imageWrapper} ref={imageRef2}>
                <img src={result2} alt="תוצאה 2" className={styles.galleryImage} />
            </div>
            <div className={styles.imageWrapper} ref={imageRef3}>
                <img src={result3} alt="תוצאה 3" className={styles.galleryImage} />
            </div>
            <div className={styles.imageWrapper} ref={imageRef4}>
                <img src={result4} alt="תוצאה 4" className={styles.galleryImage} />
            </div>
        </div>
        
        <div className={styles.videoGallery}>
            <div className={styles.videoWrapper} ref={videoRef1}>
                <video 
                    className={styles.galleryVideo}
                    muted
                    playsInline
                    controls
                >
                    <source src={video1} type="video/mp4" />
                </video>
            </div>
            <div className={styles.videoWrapper} ref={videoRef2}>
                <video 
                    className={styles.galleryVideo}
                    muted
                    playsInline
                    controls
                >
                    <source src={video2} type="video/mp4" />
                </video>
            </div>
            <div className={styles.videoWrapper} ref={videoRef3}>
                <video 
                    className={styles.galleryVideo}
                    muted
                    playsInline
                    controls
                >
                    <source src={video3} type="video/mp4" />
                </video>
            </div>
            <div className={styles.videoWrapper} ref={videoRef4}>
                <video 
                    className={styles.galleryVideo}
                    muted
                    playsInline
                    controls
                >
                    <source src={video4} type="video/mp4" />
                </video>
            </div>
                   <div className={styles.videoWrapper} ref={videoRef4}>
                <video 
                    className={styles.galleryVideo}
                    muted
                    playsInline
                    controls
                >
                    <source src={video5} type="video/mp4" />
                </video>
            </div>
        </div>

        <ShortsRec/>
        <Button text="הילה בואי נדבר!"/>
    </>
}

export default ThirdScreen